import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import Categories from './Categories.js';
import FoodCard from './FoodCards.js';
import Footer from './Footer.js';
import '../Styles/Home.css';
import ReactNotification from "react-notifications-component";

const Home = ()=> {

    const [ numProds, setNumprods] = useState( JSON.parse(localStorage.getItem("carrito")) === null
    ? 0
    : JSON.parse(localStorage.getItem("carrito")).length);

    const simpleToggler = useSelector(state => state.simpleToggler)

    return(
        <div className="home" id={ 
            simpleToggler.carrito
            ?"overflow"
            :"xd"
          }>
            <Header title="El Rancho" nums={numProds} atributo={setNumprods}/>
            <div className="titlecontainer1">
                <div className="Cate-title">Categorias</div>
            </div>
            <ReactNotification/>
            <Categories/>
            <FoodCard nums={setNumprods}/> 
            <Footer/>
        </div>
    )
}

export default Home;